// @flow
import React, { Component } from 'react';
import './Image.scss';

class Image extends Component<Props, State> {
  constructor() {
    super();
    this.state = {};
    this.fallback = () => {
      if (this.props.fallbackSrc) {
        this.setState({ failed: true });
      }
    };
  }

  render() {
    if (this.state.failed) {
      return <img src={this.props.fallbackSrc} alt={this.props.alt} />;
    }
      return <img src={this.props.src} alt={this.props.alt} onError={this.fallback} />;

  }
}
export default Image;



// WEBPACK FOOTER //
// ./src/components/base/Image/Image.js